module.exports = __webpack_public_path__ + "img/cnu_gallery6.97334b11.jpg";